import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import Select from 'react-select';
import { getQuoteByDD } from 'y4/Y4Api';
import _ from 'lodash';
import y from 'y4/Utils';

function DynamicSelect({
  dataCode,
  field,
  row,
  onChange,
  eventTarget,
  filter
}) {
  const afterSelected = newValue => {
    if (filter) {
      const dic = {};
      dic[field.name] = newValue ? newValue.value : null; //equal
      onChange(dic);
    } else {
      onChange({
        name: field.name,
        value: newValue ? newValue.value : null,
        display: newValue ? newValue.label : null
      });
    }
  };

  const onInputChange = () => {
    /*
    if (inputValue) {
      loadOption(inputValue, row);
    }
    */
  };

  const [options, setOptions] = useState([]);
  //load quote data from backend
  const loadOption = function (keyword, data) {
    getQuoteByDD(dataCode, {
      count: 0,
      field: field.name,
      keyword,
      other: y.toOther({
        rows: [y.removeUi(data)]
      })
    }).then(rt => {
      if (rt.isOk()) {
        const items = rt.data.map(item => {
          return { value: item.Key, label: item.Name };
        });
        setOptions(items);
      }
    });
  };

  //reload after changed
  var rac = _.get(field, 'other.reloadAfterChanged');

  useEffect(() => {
    //Add evet at item chaged
    if (rac) {
      eventTarget.addEventListener('itemChanged', e => {
        if (y.include(rac, y.getFieldName(e.detail.field))) {
          loadOption(null, e.detail.data.row);
          //Set current select to null
          //setValue({ value: null, label: null });
        }
      });
    }
  }, [eventTarget]);

  //Load data after UI shown
  useEffect(() => {
    loadOption(null, row);
  }, [field]);

  let dv = {
    value: y.gpv(row, field.name),
    label: y.gpv(row, field.name + 'Ui')
  };

  if (dv && dv.value && !dv.label) {
    //Has value and no label find it in options
    dv = _.find(options, ['value', dv.value]);
    if (!dv) dv = null;
  }
  if (dv && !dv.value && !dv.label) {
    //If no value and no label then to null
    dv = null;
  }

  return (
    <Form.Floating>
      <Select
        closeMenuOnSelect={true}
        isClearable={true}
        options={options}
        placeholder={
          filter ? y.et(field.valueTip, field.title) : field.valueTip
        }
        classNamePrefix="react-select"
        isMulti={field.multipleSelect}
        value={dv}
        onChange={v => afterSelected(v)}
        isDisabled={field.readonly}
        onInputChange={v => onInputChange(v)}
      />
    </Form.Floating>
  );
}

DynamicSelect.propTypes = {
  dataCode: PropTypes.string,
  field: PropTypes.object,
  row: PropTypes.object, //used to show in grid
  onChange: PropTypes.func,
  eventTarget: PropTypes.object,
  filter: PropTypes.bool //used for filter panel
};

export default DynamicSelect;
